const angular = require('angular');
var app = angular.module('learn-resources');

/**
* Defines the Content Reference Factor which provides mapping for content types
* @argument {Application} Application injected to gain access to the global Application functions and properties
*/

app.factory('ContentReference', ['Application', 'Authorization', function(Application) {
  return {
    mapSearchTypeToModel: {
      article: 'Article',
      assessment: 'Assessment',
      imported_content: 'ImportedContent',
      video: 'Media',
      file: 'Media',
      scorm: 'ScormContent',
      track: 'Track',
      workshop: 'Workshop',
      persentation: 'Presentation'
    },
  } 
}]);